import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import MintUI from 'mint-ui'

import 'mint-ui/lib/style.css'
import LyTab from "ly-tab";
// import VideoPlayer from "vue-video-player"; // video
// import FastClick from "fastclick";
import Vant from "vant";
import "vant/lib/index.css";
import "./utils/common.js"; //公共js

// import VConsole from "vconsole";
// const isDebug = true;
// // 本地开发调试注入vConsole
// if (isDebug) {
//   new VConsole();
// }

// FastClick.attach(document.body);
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(MintUI);
Vue.use(LyTab);
import { Toast } from 'vant'

Vue.prototype.$appid = "wxa036be65443d937f"
Vue.prototype.$local = encodeURI(process.env.BASE_API+'/wap/index.html')

Vue.prototype.$getSimpleText = (html) => {
  // 富文本转换
  let re1 = new RegExp("<.+?>", "g");
  let msg = (html && html.replace(re1, "")) || "";
  //替换msg中特殊字符
  msg = msg && msg.replace(/&quot;/g, '"');
  msg = msg && msg.replace(/&amp;/g, "&");
  msg = msg && msg.replace(/&lt;/g, "<");
  msg = msg && msg.replace(/&gt;/g, ">");
  msg = msg && msg.replace(/&nbsp;/g, " ");
  // console.log("转义字符", msg);
  return msg;
}

//导入
import wxApi from '@/utils/wxApi.js'
//挂载
Vue.prototype.$wxPay = wxApi.wexinPay
// Vue.prototype.goToBookOrdering = function(){
//   Toast('敬请期待')
//   return false
//   router.push({path:'/bookOrderingList'})
// }
Vue.prototype.copyText = function(value){
  const aux = document.createElement('input')
  aux.setAttribute('value', value)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  Toast('复制成功')
}
router.beforeEach(({ meta, path }, from, next) => {
  if(!localStorage.getItem("y-token")){
    let arr = ['/login/setPassword','/edit','/password','/my','/verify','/order','/confirmOrder','/address/index','/address/manage','/address/change','/orderDetail','/paymentOrder','/paymentSuccessful']
    if(path.indexOf(arr) != -1){
      next({path:'/login/sign'})
    }else{
      next();
    }
  }else{
    next();
  }
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js